/**
 * 챗봇 API 오류. **`chat.ts` 와 `chat.mock.ts` 가 둘 다 던지므로 따로 뺐다.**
 *
 * 목이 `chat.ts` 를 import 하면 `chat.ts → chat.mock.ts → chat.ts` 순환이 생긴다.
 * 클래스 하나가 그 순환의 유일한 이유였다.
 *
 * 화면은 `@/lib/api/chat` 에서 재수출된 것을 쓴다 — 이 파일을 직접 import 할 일은 없다.
 */
export class ChatApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'ChatApiError';
    this.status = status;
  }
}
